
const faqItems = document.querySelectorAll('.faq-item');

faqItems.forEach(item => {
const question = item.querySelector('.faq-question');

question.addEventListener('click', () => {
    // close others
    faqItems.forEach(i => {
    if (i !== item) i.classList.remove('active');
    });

    // toggle current
    item.classList.toggle('active');
});
});
